import { useState, useEffect } from 'react';

// Maximum number of URL history items to store (reduced from 10 to 4)
const MAX_HISTORY_ITEMS = 4;
const URL_HISTORY_KEY = 'url_history';

export function useUrlHistory() {
  const [urlHistory, setUrlHistory] = useState<string[]>([]);

  // Load history from localStorage on component mount
  useEffect(() => {
    try {
      const savedHistory = localStorage.getItem(URL_HISTORY_KEY);
      if (savedHistory) {
        setUrlHistory(JSON.parse(savedHistory));
      }
    } catch (error) {
      console.error('Error loading URL history:', error);
    }
  }, []);

  // Add URL to history
  const addToHistory = (url: string) => {
    if (!url.trim()) return;
    
    setUrlHistory(prevHistory => {
      // Remove duplicate if exists
      const filteredHistory = prevHistory.filter(item => item !== url);
      
      // Add new URL to the beginning
      const newHistory = [url, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);
      
      // Save to localStorage
      try {
        localStorage.setItem(URL_HISTORY_KEY, JSON.stringify(newHistory));
      } catch (error) {
        console.error('Error saving URL history:', error);
      }
      
      return newHistory;
    });
  };

  // Clear history
  const clearHistory = () => {
    setUrlHistory([]);
    localStorage.removeItem(URL_HISTORY_KEY);
  };
  
  // Remove specific URL from history
  const removeFromHistory = (urlToRemove: string) => {
    setUrlHistory(prevHistory => {
      const newHistory = prevHistory.filter(item => item !== urlToRemove);
      
      // Save to localStorage
      try {
        localStorage.setItem(URL_HISTORY_KEY, JSON.stringify(newHistory));
      } catch (error) {
        console.error('Error saving URL history:', error);
      }
      
      return newHistory;
    });
  };

  return {
    urlHistory,
    addToHistory,
    clearHistory,
    removeFromHistory
  };
}
